export default function PayMethodPicker({ methods, value, onChange, note }) {
  if (!methods?.length) return null;
  return (
    <div data-testid="pay-methods">
      <div className="text-sm font-semibold mb-1">Choose how to pay</div>
      {note && <p className="text-[12px] leading-5 text-aura-muted mb-3">{note}</p>}
      <div className="space-y-2">
        {methods.map((method) => {
          const on = value === method.id;
          const ready = method.ready !== false;
          return (
            <button
              key={method.id}
              type="button"
              disabled={!ready}
              onClick={() => ready && onChange(method.id)}
              data-testid={`pay-${method.id}`}
              className={`w-full text-left border px-3 py-3 disabled:opacity-70 ${on ? "border-aura-accent bg-aura-bg" : "border-aura-border hover:border-aura-accent/60"}`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold">{method.label}</span>
                {method.recommended && ready && (
                  <span className="text-[10px] uppercase tracking-wide text-aura-accent">Suggested for you</span>
                )}
                {!ready && (
                  <span className="text-[10px] uppercase tracking-wide text-aura-muted">Not set up</span>
                )}
              </div>
              <div className="text-[12px] text-aura-muted mt-1">{method.audience} · {method.summary}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
